/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import API, { graphqlOperation, GraphQLResult } from "@aws-amplify/api-graphql";
import { Observable } from "zen-observable-ts";

export interface SubscriptionResponse<T> {
  value: GraphQLResult<T>;
}

export type __SubscriptionContainer = {
  onCreateApiLog: OnCreateApiLogSubscription;
  onUpdateApiLog: OnUpdateApiLogSubscription;
  onDeleteApiLog: OnDeleteApiLogSubscription;
  onCreateTokens: OnCreateTokensSubscription;
  onUpdateTokens: OnUpdateTokensSubscription;
  onDeleteTokens: OnDeleteTokensSubscription;
  onCreateTokenTopUp: OnCreateTokenTopUpSubscription;
  onUpdateTokenTopUp: OnUpdateTokenTopUpSubscription;
  onDeleteTokenTopUp: OnDeleteTokenTopUpSubscription;
  onCreateBilling: OnCreateBillingSubscription;
  onUpdateBilling: OnUpdateBillingSubscription;
  onDeleteBilling: OnDeleteBillingSubscription;
  onCreateSumit: OnCreateSumitSubscription;
  onUpdateSumit: OnUpdateSumitSubscription;
  onDeleteSumit: OnDeleteSumitSubscription;
  onCreateSumitPayment: OnCreateSumitPaymentSubscription;
  onUpdateSumitPayment: OnUpdateSumitPaymentSubscription;
  onDeleteSumitPayment: OnDeleteSumitPaymentSubscription;
  onCreateSumitPaymentMethod: OnCreateSumitPaymentMethodSubscription;
  onUpdateSumitPaymentMethod: OnUpdateSumitPaymentMethodSubscription;
  onDeleteSumitPaymentMethod: OnDeleteSumitPaymentMethodSubscription;
};

export type CreateApiLogInput = {
  id?: string | null;
  uuid: string;
  datetime: string;
  path?: string | null;
  fileUid?: string | null;
  owner?: string | null;
  amountPerPath?: number | null;
  type?: string | null;
  clientId?: string | null;
  clientVersion?: string | null;
  clientIp?: string | null;
};

export type ModelApiLogConditionInput = {
  uuid?: ModelStringInput | null;
  datetime?: ModelStringInput | null;
  path?: ModelStringInput | null;
  fileUid?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  amountPerPath?: ModelFloatInput | null;
  type?: ModelStringInput | null;
  clientId?: ModelStringInput | null;
  clientVersion?: ModelStringInput | null;
  clientIp?: ModelStringInput | null;
  and?: Array<ModelApiLogConditionInput | null> | null;
  or?: Array<ModelApiLogConditionInput | null> | null;
  not?: ModelApiLogConditionInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null"
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type ModelFloatInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ApiLog = {
  __typename: "ApiLog";
  id: string;
  uuid: string;
  datetime: string;
  path?: string | null;
  fileUid?: string | null;
  owner?: string | null;
  amountPerPath?: number | null;
  type?: string | null;
  clientId?: string | null;
  clientVersion?: string | null;
  clientIp?: string | null;
  createdAt: string;
  updatedAt: string;
  openFlag: boolean | null;
};

export type UpdateApiLogInput = {
  id: string;
  uuid?: string | null;
  datetime?: string | null;
  path?: string | null;
  fileUid?: string | null;
  owner?: string | null;
  amountPerPath?: number | null;
  type?: string | null;
  clientId?: string | null;
  clientVersion?: string | null;
  clientIp?: string | null;
};

export type DeleteApiLogInput = {
  id: string;
};

export type CreateTokensInput = {
  id?: string | null;
  name: string;
  date: string;
  enable: boolean;
  month?: number | null;
  uuid: string;
  description?: string | null;
  type?: string | null;
  owner?: string | null;
  userExists?: boolean | null;
};

export type ModelTokensConditionInput = {
  name?: ModelStringInput | null;
  date?: ModelStringInput | null;
  enable?: ModelBooleanInput | null;
  month?: ModelIntInput | null;
  uuid?: ModelStringInput | null;
  description?: ModelStringInput | null;
  type?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  userExists?: ModelBooleanInput | null;
  and?: Array<ModelTokensConditionInput | null> | null;
  or?: Array<ModelTokensConditionInput | null> | null;
  not?: ModelTokensConditionInput | null;
};

export type ModelBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type Tokens = {
  __typename: "Tokens";
  id: string;
  name: string;
  date: string;
  enable: boolean;
  month?: number | null;
  uuid: string;
  description?: string | null;
  type?: string | null;
  owner?: string | null;
  userExists?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateTokensInput = {
  id: string;
  name?: string | null;
  date?: string | null;
  enable?: boolean | null;
  month?: number | null;
  uuid?: string | null;
  description?: string | null;
  type?: string | null;
  owner?: string | null;
  userExists?: boolean | null;
};

export type DeleteTokensInput = {
  id: string;
};

export type CreateTokenTopUpInput = {
  id?: string | null;
  token?: string | null;
  amount: number;
  action: string;
  apiLog?: string | null;
  billingId?: string | null;
  owner?: string | null;
};

export type ModelTokenTopUpConditionInput = {
  token?: ModelStringInput | null;
  amount?: ModelFloatInput | null;
  action?: ModelStringInput | null;
  apiLog?: ModelStringInput | null;
  billingId?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  and?: Array<ModelTokenTopUpConditionInput | null> | null;
  or?: Array<ModelTokenTopUpConditionInput | null> | null;
  not?: ModelTokenTopUpConditionInput | null;
};

export type TokenTopUp = {
  __typename: "TokenTopUp";
  id: string;
  token?: string | null;
  amount: number;
  action: string;
  apiLog?: string | null;
  billingId?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateTokenTopUpInput = {
  id: string;
  token?: string | null;
  amount?: number | null;
  action?: string | null;
  apiLog?: string | null;
  billingId?: string | null;
  owner?: string | null;
};

export type DeleteTokenTopUpInput = {
  id: string;
};

export type CreateBillingInput = {
  id?: string | null;
  amount?: number | null;
  amountNoTax?: number | null;
  date?: string | null;
  valid?: boolean | null;
  Billing_ShovarNumber?: string | null;
  email?: string | null;
  SKU?: string | null;
  productPrice?: number | null;
  subscriptionPrice?: number | null;
  quantity?: number | null;
  owner?: string | null;
  tokenAmount?: number | null;
  type?: string | null;
  companyId?: string | null;
  documentDownloadURL?: string | null;
};

export type ModelBillingConditionInput = {
  amount?: ModelFloatInput | null;
  amountNoTax?: ModelFloatInput | null;
  date?: ModelStringInput | null;
  valid?: ModelBooleanInput | null;
  Billing_ShovarNumber?: ModelStringInput | null;
  email?: ModelStringInput | null;
  SKU?: ModelStringInput | null;
  productPrice?: ModelFloatInput | null;
  subscriptionPrice?: ModelFloatInput | null;
  quantity?: ModelIntInput | null;
  owner?: ModelStringInput | null;
  tokenAmount?: ModelFloatInput | null;
  type?: ModelStringInput | null;
  companyId?: ModelStringInput | null;
  documentDownloadURL?: ModelStringInput | null;
  and?: Array<ModelBillingConditionInput | null> | null;
  or?: Array<ModelBillingConditionInput | null> | null;
  not?: ModelBillingConditionInput | null;
};

export type Billing = {
  __typename: "Billing";
  id: string;
  amount?: number | null;
  amountNoTax?: number | null;
  date?: string | null;
  valid?: boolean | null;
  Billing_ShovarNumber?: string | null;
  email?: string | null;
  SKU?: string | null;
  productPrice?: number | null;
  subscriptionPrice?: number | null;
  quantity?: number | null;
  owner?: string | null;
  tokenAmount?: number | null;
  type?: string | null;
  companyId?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateBillingInput = {
  id: string;
  amount?: number | null;
  amountNoTax?: number | null;
  date?: string | null;
  valid?: boolean | null;
  Billing_ShovarNumber?: string | null;
  email?: string | null;
  SKU?: string | null;
  productPrice?: number | null;
  subscriptionPrice?: number | null;
  quantity?: number | null;
  owner?: string | null;
  tokenAmount?: number | null;
  type?: string | null;
  companyId?: string | null;
  documentDownloadURL?: string | null;
};

export type DeleteBillingInput = {
  id: string;
};

export type CreateSumitInput = {
  id?: string | null;
  customerId?: string | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  companyNumber?: string | null;
  customerHistoryURL?: string | null;
  owner?: string | null;
};

export type ModelSumitConditionInput = {
  customerId?: ModelStringInput | null;
  name?: ModelStringInput | null;
  phone?: ModelStringInput | null;
  email?: ModelStringInput | null;
  companyNumber?: ModelStringInput | null;
  customerHistoryURL?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  and?: Array<ModelSumitConditionInput | null> | null;
  or?: Array<ModelSumitConditionInput | null> | null;
  not?: ModelSumitConditionInput | null;
};

export type Sumit = {
  __typename: "Sumit";
  id: string;
  customerId?: string | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  companyNumber?: string | null;
  customerHistoryURL?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateSumitInput = {
  id: string;
  customerId?: string | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  companyNumber?: string | null;
  customerHistoryURL?: string | null;
  owner?: string | null;
};

export type DeleteSumitInput = {
  id: string;
};

export type CreateSumitPaymentInput = {
  id?: string | null;
  status?: string | null;
  OGCustomerID?: string | null;
  OGPaymentID?: string | null;
  OGPaymentType?: string | null;
  OGDocumentNumber?: string | null;
  subscriptionPrice?: number | null;
  owner?: string | null;
  documentDownloadURL?: string | null;
};

export type ModelSumitPaymentConditionInput = {
  status?: ModelStringInput | null;
  OGCustomerID?: ModelStringInput | null;
  OGPaymentID?: ModelStringInput | null;
  OGPaymentType?: ModelStringInput | null;
  OGDocumentNumber?: ModelStringInput | null;
  subscriptionPrice?: ModelFloatInput | null;
  owner?: ModelStringInput | null;
  documentDownloadURL?: ModelStringInput | null;
  and?: Array<ModelSumitPaymentConditionInput | null> | null;
  or?: Array<ModelSumitPaymentConditionInput | null> | null;
  not?: ModelSumitPaymentConditionInput | null;
};

export type SumitPayment = {
  __typename: "SumitPayment";
  id: string;
  status?: string | null;
  OGCustomerID?: string | null;
  OGPaymentID?: string | null;
  OGPaymentType?: string | null;
  OGDocumentNumber?: string | null;
  subscriptionPrice?: number | null;
  owner?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateSumitPaymentInput = {
  id: string;
  status?: string | null;
  OGCustomerID?: string | null;
  OGPaymentID?: string | null;
  OGPaymentType?: string | null;
  OGDocumentNumber?: string | null;
  subscriptionPrice?: number | null;
  owner?: string | null;
  documentDownloadURL?: string | null;
};

export type DeleteSumitPaymentInput = {
  id: string;
};

export type CreateSumitPaymentMethodInput = {
  id?: string | null;
  status?: string | null;
  PaymentMethodID?: string | null;
  CustomerID?: string | null;
  CompanyID?: string | null;
  CardMask?: string | null;
  LastDigits?: string | null;
  ExpirationMonth?: number | null;
  ExpirationYear?: number | null;
  Token?: string | null;
  Type?: string | null;
  owner?: string | null;
};

export type ModelSumitPaymentMethodConditionInput = {
  status?: ModelStringInput | null;
  PaymentMethodID?: ModelStringInput | null;
  CustomerID?: ModelStringInput | null;
  CompanyID?: ModelStringInput | null;
  CardMask?: ModelStringInput | null;
  LastDigits?: ModelStringInput | null;
  ExpirationMonth?: ModelIntInput | null;
  ExpirationYear?: ModelIntInput | null;
  Token?: ModelStringInput | null;
  Type?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  and?: Array<ModelSumitPaymentMethodConditionInput | null> | null;
  or?: Array<ModelSumitPaymentMethodConditionInput | null> | null;
  not?: ModelSumitPaymentMethodConditionInput | null;
};

export type SumitPaymentMethod = {
  __typename: "SumitPaymentMethod";
  id: string;
  status?: string | null;
  PaymentMethodID?: string | null;
  CustomerID?: string | null;
  CompanyID?: string | null;
  CardMask?: string | null;
  LastDigits?: string | null;
  ExpirationMonth?: number | null;
  ExpirationYear?: number | null;
  Token?: string | null;
  Type?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateSumitPaymentMethodInput = {
  id: string;
  status?: string | null;
  PaymentMethodID?: string | null;
  CustomerID?: string | null;
  CompanyID?: string | null;
  CardMask?: string | null;
  LastDigits?: string | null;
  ExpirationMonth?: number | null;
  ExpirationYear?: number | null;
  Token?: string | null;
  Type?: string | null;
  owner?: string | null;
};

export type DeleteSumitPaymentMethodInput = {
  id: string;
};

export type ModelApiLogFilterInput = {
  id?: ModelIDInput | null;
  uuid?: ModelStringInput | null;
  datetime?: ModelStringInput | null;
  path?: ModelStringInput | null;
  fileUid?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  amountPerPath?: ModelFloatInput | null;
  type?: ModelStringInput | null;
  clientId?: ModelStringInput | null;
  clientVersion?: ModelStringInput | null;
  clientIp?: ModelStringInput | null;
  and?: Array<ModelApiLogFilterInput | null> | null;
  or?: Array<ModelApiLogFilterInput | null> | null;
  not?: ModelApiLogFilterInput | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type ModelApiLogConnection = {
  __typename: "ModelApiLogConnection";
  items: Array<ApiLog | null>;
  nextToken?: string | null;
};

export type ModelTokensFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  date?: ModelStringInput | null;
  enable?: ModelBooleanInput | null;
  month?: ModelIntInput | null;
  uuid?: ModelStringInput | null;
  description?: ModelStringInput | null;
  type?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  userExists?: ModelBooleanInput | null;
  and?: Array<ModelTokensFilterInput | null> | null;
  or?: Array<ModelTokensFilterInput | null> | null;
  not?: ModelTokensFilterInput | null;
};

export type ModelTokensConnection = {
  __typename: "ModelTokensConnection";
  items: Array<Tokens | null>;
  nextToken?: string | null;
};

export type ModelTokenTopUpFilterInput = {
  id?: ModelIDInput | null;
  token?: ModelStringInput | null;
  amount?: ModelFloatInput | null;
  action?: ModelStringInput | null;
  apiLog?: ModelStringInput | null;
  billingId?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  and?: Array<ModelTokenTopUpFilterInput | null> | null;
  or?: Array<ModelTokenTopUpFilterInput | null> | null;
  not?: ModelTokenTopUpFilterInput | null;
};

export type ModelTokenTopUpConnection = {
  __typename: "ModelTokenTopUpConnection";
  items: Array<TokenTopUp | null>;
  nextToken?: string | null;
};

export type ModelBillingFilterInput = {
  id?: ModelIDInput | null;
  amount?: ModelFloatInput | null;
  amountNoTax?: ModelFloatInput | null;
  date?: ModelStringInput | null;
  valid?: ModelBooleanInput | null;
  Billing_ShovarNumber?: ModelStringInput | null;
  email?: ModelStringInput | null;
  SKU?: ModelStringInput | null;
  productPrice?: ModelFloatInput | null;
  subscriptionPrice?: ModelFloatInput | null;
  quantity?: ModelIntInput | null;
  owner?: ModelStringInput | null;
  tokenAmount?: ModelFloatInput | null;
  type?: ModelStringInput | null;
  companyId?: ModelStringInput | null;
  documentDownloadURL?: ModelStringInput | null;
  and?: Array<ModelBillingFilterInput | null> | null;
  or?: Array<ModelBillingFilterInput | null> | null;
  not?: ModelBillingFilterInput | null;
};

export type ModelBillingConnection = {
  __typename: "ModelBillingConnection";
  items: Array<Billing | null>;
  nextToken?: string | null;
};

export type ModelSumitFilterInput = {
  id?: ModelIDInput | null;
  customerId?: ModelStringInput | null;
  name?: ModelStringInput | null;
  phone?: ModelStringInput | null;
  email?: ModelStringInput | null;
  companyNumber?: ModelStringInput | null;
  customerHistoryURL?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  and?: Array<ModelSumitFilterInput | null> | null;
  or?: Array<ModelSumitFilterInput | null> | null;
  not?: ModelSumitFilterInput | null;
};

export type ModelSumitConnection = {
  __typename: "ModelSumitConnection";
  items: Array<Sumit | null>;
  nextToken?: string | null;
};

export type ModelSumitPaymentFilterInput = {
  id?: ModelIDInput | null;
  status?: ModelStringInput | null;
  OGCustomerID?: ModelStringInput | null;
  OGPaymentID?: ModelStringInput | null;
  OGPaymentType?: ModelStringInput | null;
  OGDocumentNumber?: ModelStringInput | null;
  subscriptionPrice?: ModelFloatInput | null;
  owner?: ModelStringInput | null;
  documentDownloadURL?: ModelStringInput | null;
  and?: Array<ModelSumitPaymentFilterInput | null> | null;
  or?: Array<ModelSumitPaymentFilterInput | null> | null;
  not?: ModelSumitPaymentFilterInput | null;
};

export type ModelSumitPaymentConnection = {
  __typename: "ModelSumitPaymentConnection";
  items: Array<SumitPayment | null>;
  nextToken?: string | null;
};

export type ModelSumitPaymentMethodFilterInput = {
  id?: ModelIDInput | null;
  status?: ModelStringInput | null;
  PaymentMethodID?: ModelStringInput | null;
  CustomerID?: ModelStringInput | null;
  CompanyID?: ModelStringInput | null;
  CardMask?: ModelStringInput | null;
  LastDigits?: ModelStringInput | null;
  ExpirationMonth?: ModelIntInput | null;
  ExpirationYear?: ModelIntInput | null;
  Token?: ModelStringInput | null;
  Type?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  and?: Array<ModelSumitPaymentMethodFilterInput | null> | null;
  or?: Array<ModelSumitPaymentMethodFilterInput | null> | null;
  not?: ModelSumitPaymentMethodFilterInput | null;
};

export type ModelSumitPaymentMethodConnection = {
  __typename: "ModelSumitPaymentMethodConnection";
  items: Array<SumitPaymentMethod | null>;
  nextToken?: string | null;
};

export type ModelSubscriptionApiLogFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  uuid?: ModelSubscriptionStringInput | null;
  datetime?: ModelSubscriptionStringInput | null;
  path?: ModelSubscriptionStringInput | null;
  fileUid?: ModelSubscriptionStringInput | null;
  amountPerPath?: ModelSubscriptionFloatInput | null;
  type?: ModelSubscriptionStringInput | null;
  clientId?: ModelSubscriptionStringInput | null;
  clientVersion?: ModelSubscriptionStringInput | null;
  clientIp?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionApiLogFilterInput | null> | null;
  or?: Array<ModelSubscriptionApiLogFilterInput | null> | null;
};

export type ModelSubscriptionIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  in?: Array<number | null> | null;
  notIn?: Array<number | null> | null;
};

export type ModelSubscriptionTokensFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  date?: ModelSubscriptionStringInput | null;
  enable?: ModelSubscriptionBooleanInput | null;
  month?: ModelSubscriptionIntInput | null;
  uuid?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  type?: ModelSubscriptionStringInput | null;
  userExists?: ModelSubscriptionBooleanInput | null;
  and?: Array<ModelSubscriptionTokensFilterInput | null> | null;
  or?: Array<ModelSubscriptionTokensFilterInput | null> | null;
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
};

export type ModelSubscriptionIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  in?: Array<number | null> | null;
  notIn?: Array<number | null> | null;
};

export type ModelSubscriptionTokenTopUpFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  token?: ModelSubscriptionStringInput | null;
  amount?: ModelSubscriptionFloatInput | null;
  action?: ModelSubscriptionStringInput | null;
  apiLog?: ModelSubscriptionStringInput | null;
  billingId?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionTokenTopUpFilterInput | null> | null;
  or?: Array<ModelSubscriptionTokenTopUpFilterInput | null> | null;
};

export type ModelSubscriptionBillingFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  amount?: ModelSubscriptionFloatInput | null;
  amountNoTax?: ModelSubscriptionFloatInput | null;
  date?: ModelSubscriptionStringInput | null;
  valid?: ModelSubscriptionBooleanInput | null;
  Billing_ShovarNumber?: ModelSubscriptionStringInput | null;
  email?: ModelSubscriptionStringInput | null;
  SKU?: ModelSubscriptionStringInput | null;
  productPrice?: ModelSubscriptionFloatInput | null;
  subscriptionPrice?: ModelSubscriptionFloatInput | null;
  quantity?: ModelSubscriptionIntInput | null;
  tokenAmount?: ModelSubscriptionFloatInput | null;
  type?: ModelSubscriptionStringInput | null;
  companyId?: ModelSubscriptionStringInput | null;
  documentDownloadURL?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionBillingFilterInput | null> | null;
  or?: Array<ModelSubscriptionBillingFilterInput | null> | null;
};

export type ModelSubscriptionSumitFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  customerId?: ModelSubscriptionStringInput | null;
  name?: ModelSubscriptionStringInput | null;
  phone?: ModelSubscriptionStringInput | null;
  email?: ModelSubscriptionStringInput | null;
  companyNumber?: ModelSubscriptionStringInput | null;
  customerHistoryURL?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionSumitFilterInput | null> | null;
  or?: Array<ModelSubscriptionSumitFilterInput | null> | null;
};

export type ModelSubscriptionSumitPaymentFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  status?: ModelSubscriptionStringInput | null;
  OGCustomerID?: ModelSubscriptionStringInput | null;
  OGPaymentID?: ModelSubscriptionStringInput | null;
  OGPaymentType?: ModelSubscriptionStringInput | null;
  OGDocumentNumber?: ModelSubscriptionStringInput | null;
  subscriptionPrice?: ModelSubscriptionFloatInput | null;
  documentDownloadURL?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionSumitPaymentFilterInput | null> | null;
  or?: Array<ModelSubscriptionSumitPaymentFilterInput | null> | null;
};

export type ModelSubscriptionSumitPaymentMethodFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  status?: ModelSubscriptionStringInput | null;
  PaymentMethodID?: ModelSubscriptionStringInput | null;
  CustomerID?: ModelSubscriptionStringInput | null;
  CompanyID?: ModelSubscriptionStringInput | null;
  CardMask?: ModelSubscriptionStringInput | null;
  LastDigits?: ModelSubscriptionStringInput | null;
  ExpirationMonth?: ModelSubscriptionIntInput | null;
  ExpirationYear?: ModelSubscriptionIntInput | null;
  Token?: ModelSubscriptionStringInput | null;
  Type?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionSumitPaymentMethodFilterInput | null> | null;
  or?: Array<ModelSubscriptionSumitPaymentMethodFilterInput | null> | null;
};

export type CreateApiLogMutation = {
  __typename: "ApiLog";
  id: string;
  uuid: string;
  datetime: string;
  path?: string | null;
  fileUid?: string | null;
  owner?: string | null;
  amountPerPath?: number | null;
  type?: string | null;
  clientId?: string | null;
  clientVersion?: string | null;
  clientIp?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateApiLogMutation = {
  __typename: "ApiLog";
  id: string;
  uuid: string;
  datetime: string;
  path?: string | null;
  fileUid?: string | null;
  owner?: string | null;
  amountPerPath?: number | null;
  type?: string | null;
  clientId?: string | null;
  clientVersion?: string | null;
  clientIp?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteApiLogMutation = {
  __typename: "ApiLog";
  id: string;
  uuid: string;
  datetime: string;
  path?: string | null;
  fileUid?: string | null;
  owner?: string | null;
  amountPerPath?: number | null;
  type?: string | null;
  clientId?: string | null;
  clientVersion?: string | null;
  clientIp?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateTokensMutation = {
  __typename: "Tokens";
  id: string;
  name: string;
  date: string;
  enable: boolean;
  month?: number | null;
  uuid: string;
  description?: string | null;
  type?: string | null;
  owner?: string | null;
  userExists?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateTokensMutation = {
  __typename: "Tokens";
  id: string;
  name: string;
  date: string;
  enable: boolean;
  month?: number | null;
  uuid: string;
  description?: string | null;
  type?: string | null;
  owner?: string | null;
  userExists?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteTokensMutation = {
  __typename: "Tokens";
  id: string;
  name: string;
  date: string;
  enable: boolean;
  month?: number | null;
  uuid: string;
  description?: string | null;
  type?: string | null;
  owner?: string | null;
  userExists?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateTokenTopUpMutation = {
  __typename: "TokenTopUp";
  id: string;
  token?: string | null;
  amount: number;
  action: string;
  apiLog?: string | null;
  billingId?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateTokenTopUpMutation = {
  __typename: "TokenTopUp";
  id: string;
  token?: string | null;
  amount: number;
  action: string;
  apiLog?: string | null;
  billingId?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteTokenTopUpMutation = {
  __typename: "TokenTopUp";
  id: string;
  token?: string | null;
  amount: number;
  action: string;
  apiLog?: string | null;
  billingId?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateBillingMutation = {
  __typename: "Billing";
  id: string;
  amount?: number | null;
  amountNoTax?: number | null;
  date?: string | null;
  valid?: boolean | null;
  Billing_ShovarNumber?: string | null;
  email?: string | null;
  SKU?: string | null;
  productPrice?: number | null;
  subscriptionPrice?: number | null;
  quantity?: number | null;
  owner?: string | null;
  tokenAmount?: number | null;
  type?: string | null;
  companyId?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateBillingMutation = {
  __typename: "Billing";
  id: string;
  amount?: number | null;
  amountNoTax?: number | null;
  date?: string | null;
  valid?: boolean | null;
  Billing_ShovarNumber?: string | null;
  email?: string | null;
  SKU?: string | null;
  productPrice?: number | null;
  subscriptionPrice?: number | null;
  quantity?: number | null;
  owner?: string | null;
  tokenAmount?: number | null;
  type?: string | null;
  companyId?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteBillingMutation = {
  __typename: "Billing";
  id: string;
  amount?: number | null;
  amountNoTax?: number | null;
  date?: string | null;
  valid?: boolean | null;
  Billing_ShovarNumber?: string | null;
  email?: string | null;
  SKU?: string | null;
  productPrice?: number | null;
  subscriptionPrice?: number | null;
  quantity?: number | null;
  owner?: string | null;
  tokenAmount?: number | null;
  type?: string | null;
  companyId?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateSumitMutation = {
  __typename: "Sumit";
  id: string;
  customerId?: string | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  companyNumber?: string | null;
  customerHistoryURL?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateSumitMutation = {
  __typename: "Sumit";
  id: string;
  customerId?: string | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  companyNumber?: string | null;
  customerHistoryURL?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteSumitMutation = {
  __typename: "Sumit";
  id: string;
  customerId?: string | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  companyNumber?: string | null;
  customerHistoryURL?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateSumitPaymentMutation = {
  __typename: "SumitPayment";
  id: string;
  status?: string | null;
  OGCustomerID?: string | null;
  OGPaymentID?: string | null;
  OGPaymentType?: string | null;
  OGDocumentNumber?: string | null;
  subscriptionPrice?: number | null;
  owner?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateSumitPaymentMutation = {
  __typename: "SumitPayment";
  id: string;
  status?: string | null;
  OGCustomerID?: string | null;
  OGPaymentID?: string | null;
  OGPaymentType?: string | null;
  OGDocumentNumber?: string | null;
  subscriptionPrice?: number | null;
  owner?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteSumitPaymentMutation = {
  __typename: "SumitPayment";
  id: string;
  status?: string | null;
  OGCustomerID?: string | null;
  OGPaymentID?: string | null;
  OGPaymentType?: string | null;
  OGDocumentNumber?: string | null;
  subscriptionPrice?: number | null;
  owner?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateSumitPaymentMethodMutation = {
  __typename: "SumitPaymentMethod";
  id: string;
  status?: string | null;
  PaymentMethodID?: string | null;
  CustomerID?: string | null;
  CompanyID?: string | null;
  CardMask?: string | null;
  LastDigits?: string | null;
  ExpirationMonth?: number | null;
  ExpirationYear?: number | null;
  Token?: string | null;
  Type?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateSumitPaymentMethodMutation = {
  __typename: "SumitPaymentMethod";
  id: string;
  status?: string | null;
  PaymentMethodID?: string | null;
  CustomerID?: string | null;
  CompanyID?: string | null;
  CardMask?: string | null;
  LastDigits?: string | null;
  ExpirationMonth?: number | null;
  ExpirationYear?: number | null;
  Token?: string | null;
  Type?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteSumitPaymentMethodMutation = {
  __typename: "SumitPaymentMethod";
  id: string;
  status?: string | null;
  PaymentMethodID?: string | null;
  CustomerID?: string | null;
  CompanyID?: string | null;
  CardMask?: string | null;
  LastDigits?: string | null;
  ExpirationMonth?: number | null;
  ExpirationYear?: number | null;
  Token?: string | null;
  Type?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type GetApiLogQuery = {
  __typename: "ApiLog";
  id: string;
  uuid: string;
  datetime: string;
  path?: string | null;
  fileUid?: string | null;
  owner?: string | null;
  amountPerPath?: number | null;
  type?: string | null;
  clientId?: string | null;
  clientVersion?: string | null;
  clientIp?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListApiLogsQuery = {
  __typename: "ModelApiLogConnection";
  items: Array<{
    __typename: "ApiLog";
    id: string;
    uuid: string;
    datetime: string;
    path?: string | null;
    fileUid?: string | null;
    owner?: string | null;
    amountPerPath?: number | null;
    type?: string | null;
    clientId?: string | null;
    clientVersion?: string | null;
    clientIp?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetTokensQuery = {
  __typename: "Tokens";
  id: string;
  name: string;
  date: string;
  enable: boolean;
  month?: number | null;
  uuid: string;
  description?: string | null;
  type?: string | null;
  owner?: string | null;
  userExists?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type ListTokensQuery = {
  __typename: "ModelTokensConnection";
  items: Array<{
    __typename: "Tokens";
    id: string;
    name: string;
    date: string;
    enable: boolean;
    month?: number | null;
    uuid: string;
    description?: string | null;
    type?: string | null;
    owner?: string | null;
    userExists?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetTokenTopUpQuery = {
  __typename: "TokenTopUp";
  id: string;
  token?: string | null;
  amount: number;
  action: string;
  apiLog?: string | null;
  billingId?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListTokenTopUpsQuery = {
  __typename: "ModelTokenTopUpConnection";
  items: Array<{
    __typename: "TokenTopUp";
    id: string;
    token?: string | null;
    amount: number;
    action: string;
    apiLog?: string | null;
    billingId?: string | null;
    owner?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetBillingQuery = {
  __typename: "Billing";
  id: string;
  amount?: number | null;
  amountNoTax?: number | null;
  date?: string | null;
  valid?: boolean | null;
  Billing_ShovarNumber?: string | null;
  email?: string | null;
  SKU?: string | null;
  productPrice?: number | null;
  subscriptionPrice?: number | null;
  quantity?: number | null;
  owner?: string | null;
  tokenAmount?: number | null;
  type?: string | null;
  companyId?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListBillingsQuery = {
  __typename: "ModelBillingConnection";
  items: Array<{
    __typename: "Billing";
    id: string;
    amount?: number | null;
    amountNoTax?: number | null;
    date?: string | null;
    valid?: boolean | null;
    Billing_ShovarNumber?: string | null;
    email?: string | null;
    SKU?: string | null;
    productPrice?: number | null;
    subscriptionPrice?: number | null;
    quantity?: number | null;
    owner?: string | null;
    tokenAmount?: number | null;
    type?: string | null;
    companyId?: string | null;
    documentDownloadURL?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetSumitQuery = {
  __typename: "Sumit";
  id: string;
  customerId?: string | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  companyNumber?: string | null;
  customerHistoryURL?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListSumitsQuery = {
  __typename: "ModelSumitConnection";
  items: Array<{
    __typename: "Sumit";
    id: string;
    customerId?: string | null;
    name?: string | null;
    phone?: string | null;
    email?: string | null;
    companyNumber?: string | null;
    customerHistoryURL?: string | null;
    owner?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetSumitPaymentQuery = {
  __typename: "SumitPayment";
  id: string;
  status?: string | null;
  OGCustomerID?: string | null;
  OGPaymentID?: string | null;
  OGPaymentType?: string | null;
  OGDocumentNumber?: string | null;
  subscriptionPrice?: number | null;
  owner?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListSumitPaymentsQuery = {
  __typename: "ModelSumitPaymentConnection";
  items: Array<{
    __typename: "SumitPayment";
    id: string;
    status?: string | null;
    OGCustomerID?: string | null;
    OGPaymentID?: string | null;
    OGPaymentType?: string | null;
    OGDocumentNumber?: string | null;
    subscriptionPrice?: number | null;
    owner?: string | null;
    documentDownloadURL?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetSumitPaymentMethodQuery = {
  __typename: "SumitPaymentMethod";
  id: string;
  status?: string | null;
  PaymentMethodID?: string | null;
  CustomerID?: string | null;
  CompanyID?: string | null;
  CardMask?: string | null;
  LastDigits?: string | null;
  ExpirationMonth?: number | null;
  ExpirationYear?: number | null;
  Token?: string | null;
  Type?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListSumitPaymentMethodsQuery = {
  __typename: "ModelSumitPaymentMethodConnection";
  items: Array<{
    __typename: "SumitPaymentMethod";
    id: string;
    status?: string | null;
    PaymentMethodID?: string | null;
    CustomerID?: string | null;
    CompanyID?: string | null;
    CardMask?: string | null;
    LastDigits?: string | null;
    ExpirationMonth?: number | null;
    ExpirationYear?: number | null;
    Token?: string | null;
    Type?: string | null;
    owner?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type OnCreateApiLogSubscription = {
  __typename: "ApiLog";
  id: string;
  uuid: string;
  datetime: string;
  path?: string | null;
  fileUid?: string | null;
  owner?: string | null;
  amountPerPath?: number | null;
  type?: string | null;
  clientId?: string | null;
  clientVersion?: string | null;
  clientIp?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateApiLogSubscription = {
  __typename: "ApiLog";
  id: string;
  uuid: string;
  datetime: string;
  path?: string | null;
  fileUid?: string | null;
  owner?: string | null;
  amountPerPath?: number | null;
  type?: string | null;
  clientId?: string | null;
  clientVersion?: string | null;
  clientIp?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteApiLogSubscription = {
  __typename: "ApiLog";
  id: string;
  uuid: string;
  datetime: string;
  path?: string | null;
  fileUid?: string | null;
  owner?: string | null;
  amountPerPath?: number | null;
  type?: string | null;
  clientId?: string | null;
  clientVersion?: string | null;
  clientIp?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateTokensSubscription = {
  __typename: "Tokens";
  id: string;
  name: string;
  date: string;
  enable: boolean;
  month?: number | null;
  uuid: string;
  description?: string | null;
  type?: string | null;
  owner?: string | null;
  userExists?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateTokensSubscription = {
  __typename: "Tokens";
  id: string;
  name: string;
  date: string;
  enable: boolean;
  month?: number | null;
  uuid: string;
  description?: string | null;
  type?: string | null;
  owner?: string | null;
  userExists?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteTokensSubscription = {
  __typename: "Tokens";
  id: string;
  name: string;
  date: string;
  enable: boolean;
  month?: number | null;
  uuid: string;
  description?: string | null;
  type?: string | null;
  owner?: string | null;
  userExists?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateTokenTopUpSubscription = {
  __typename: "TokenTopUp";
  id: string;
  token?: string | null;
  amount: number;
  action: string;
  apiLog?: string | null;
  billingId?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateTokenTopUpSubscription = {
  __typename: "TokenTopUp";
  id: string;
  token?: string | null;
  amount: number;
  action: string;
  apiLog?: string | null;
  billingId?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteTokenTopUpSubscription = {
  __typename: "TokenTopUp";
  id: string;
  token?: string | null;
  amount: number;
  action: string;
  apiLog?: string | null;
  billingId?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateBillingSubscription = {
  __typename: "Billing";
  id: string;
  amount?: number | null;
  amountNoTax?: number | null;
  date?: string | null;
  valid?: boolean | null;
  Billing_ShovarNumber?: string | null;
  email?: string | null;
  SKU?: string | null;
  productPrice?: number | null;
  subscriptionPrice?: number | null;
  quantity?: number | null;
  owner?: string | null;
  tokenAmount?: number | null;
  type?: string | null;
  companyId?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateBillingSubscription = {
  __typename: "Billing";
  id: string;
  amount?: number | null;
  amountNoTax?: number | null;
  date?: string | null;
  valid?: boolean | null;
  Billing_ShovarNumber?: string | null;
  email?: string | null;
  SKU?: string | null;
  productPrice?: number | null;
  subscriptionPrice?: number | null;
  quantity?: number | null;
  owner?: string | null;
  tokenAmount?: number | null;
  type?: string | null;
  companyId?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteBillingSubscription = {
  __typename: "Billing";
  id: string;
  amount?: number | null;
  amountNoTax?: number | null;
  date?: string | null;
  valid?: boolean | null;
  Billing_ShovarNumber?: string | null;
  email?: string | null;
  SKU?: string | null;
  productPrice?: number | null;
  subscriptionPrice?: number | null;
  quantity?: number | null;
  owner?: string | null;
  tokenAmount?: number | null;
  type?: string | null;
  companyId?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateSumitSubscription = {
  __typename: "Sumit";
  id: string;
  customerId?: string | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  companyNumber?: string | null;
  customerHistoryURL?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateSumitSubscription = {
  __typename: "Sumit";
  id: string;
  customerId?: string | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  companyNumber?: string | null;
  customerHistoryURL?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteSumitSubscription = {
  __typename: "Sumit";
  id: string;
  customerId?: string | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  companyNumber?: string | null;
  customerHistoryURL?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateSumitPaymentSubscription = {
  __typename: "SumitPayment";
  id: string;
  status?: string | null;
  OGCustomerID?: string | null;
  OGPaymentID?: string | null;
  OGPaymentType?: string | null;
  OGDocumentNumber?: string | null;
  subscriptionPrice?: number | null;
  owner?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateSumitPaymentSubscription = {
  __typename: "SumitPayment";
  id: string;
  status?: string | null;
  OGCustomerID?: string | null;
  OGPaymentID?: string | null;
  OGPaymentType?: string | null;
  OGDocumentNumber?: string | null;
  subscriptionPrice?: number | null;
  owner?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteSumitPaymentSubscription = {
  __typename: "SumitPayment";
  id: string;
  status?: string | null;
  OGCustomerID?: string | null;
  OGPaymentID?: string | null;
  OGPaymentType?: string | null;
  OGDocumentNumber?: string | null;
  subscriptionPrice?: number | null;
  owner?: string | null;
  documentDownloadURL?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateSumitPaymentMethodSubscription = {
  __typename: "SumitPaymentMethod";
  id: string;
  status?: string | null;
  PaymentMethodID?: string | null;
  CustomerID?: string | null;
  CompanyID?: string | null;
  CardMask?: string | null;
  LastDigits?: string | null;
  ExpirationMonth?: number | null;
  ExpirationYear?: number | null;
  Token?: string | null;
  Type?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateSumitPaymentMethodSubscription = {
  __typename: "SumitPaymentMethod";
  id: string;
  status?: string | null;
  PaymentMethodID?: string | null;
  CustomerID?: string | null;
  CompanyID?: string | null;
  CardMask?: string | null;
  LastDigits?: string | null;
  ExpirationMonth?: number | null;
  ExpirationYear?: number | null;
  Token?: string | null;
  Type?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteSumitPaymentMethodSubscription = {
  __typename: "SumitPaymentMethod";
  id: string;
  status?: string | null;
  PaymentMethodID?: string | null;
  CustomerID?: string | null;
  CompanyID?: string | null;
  CardMask?: string | null;
  LastDigits?: string | null;
  ExpirationMonth?: number | null;
  ExpirationYear?: number | null;
  Token?: string | null;
  Type?: string | null;
  owner?: string | null;
  createdAt: string;
  updatedAt: string;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async CreateApiLog(
    input: CreateApiLogInput,
    condition?: ModelApiLogConditionInput
  ): Promise<CreateApiLogMutation> {
    const statement = `mutation CreateApiLog($input: CreateApiLogInput!, $condition: ModelApiLogConditionInput) {
        createApiLog(input: $input, condition: $condition) {
          __typename
          id
          uuid
          datetime
          path
          fileUid
          owner
          amountPerPath
          type
          clientId
          clientVersion
          clientIp
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateApiLogMutation>response.data.createApiLog;
  }
  async UpdateApiLog(
    input: UpdateApiLogInput,
    condition?: ModelApiLogConditionInput
  ): Promise<UpdateApiLogMutation> {
    const statement = `mutation UpdateApiLog($input: UpdateApiLogInput!, $condition: ModelApiLogConditionInput) {
        updateApiLog(input: $input, condition: $condition) {
          __typename
          id
          uuid
          datetime
          path
          fileUid
          owner
          amountPerPath
          type
          clientId
          clientVersion
          clientIp
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateApiLogMutation>response.data.updateApiLog;
  }
  async DeleteApiLog(
    input: DeleteApiLogInput,
    condition?: ModelApiLogConditionInput
  ): Promise<DeleteApiLogMutation> {
    const statement = `mutation DeleteApiLog($input: DeleteApiLogInput!, $condition: ModelApiLogConditionInput) {
        deleteApiLog(input: $input, condition: $condition) {
          __typename
          id
          uuid
          datetime
          path
          fileUid
          owner
          amountPerPath
          type
          clientId
          clientVersion
          clientIp
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteApiLogMutation>response.data.deleteApiLog;
  }
  async CreateTokens(
    input: CreateTokensInput,
    condition?: ModelTokensConditionInput
  ): Promise<CreateTokensMutation> {
    const statement = `mutation CreateTokens($input: CreateTokensInput!, $condition: ModelTokensConditionInput) {
        createTokens(input: $input, condition: $condition) {
          __typename
          id
          name
          date
          enable
          month
          uuid
          description
          type
          owner
          userExists
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateTokensMutation>response.data.createTokens;
  }
  async UpdateTokens(
    input: UpdateTokensInput,
    condition?: ModelTokensConditionInput
  ): Promise<UpdateTokensMutation> {
    const statement = `mutation UpdateTokens($input: UpdateTokensInput!, $condition: ModelTokensConditionInput) {
        updateTokens(input: $input, condition: $condition) {
          __typename
          id
          name
          date
          enable
          month
          uuid
          description
          type
          owner
          userExists
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateTokensMutation>response.data.updateTokens;
  }
  async DeleteTokens(
    input: DeleteTokensInput,
    condition?: ModelTokensConditionInput
  ): Promise<DeleteTokensMutation> {
    const statement = `mutation DeleteTokens($input: DeleteTokensInput!, $condition: ModelTokensConditionInput) {
        deleteTokens(input: $input, condition: $condition) {
          __typename
          id
          name
          date
          enable
          month
          uuid
          description
          type
          owner
          userExists
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteTokensMutation>response.data.deleteTokens;
  }
  async CreateTokenTopUp(
    input: CreateTokenTopUpInput,
    condition?: ModelTokenTopUpConditionInput
  ): Promise<CreateTokenTopUpMutation> {
    const statement = `mutation CreateTokenTopUp($input: CreateTokenTopUpInput!, $condition: ModelTokenTopUpConditionInput) {
        createTokenTopUp(input: $input, condition: $condition) {
          __typename
          id
          token
          amount
          action
          apiLog
          billingId
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateTokenTopUpMutation>response.data.createTokenTopUp;
  }
  async UpdateTokenTopUp(
    input: UpdateTokenTopUpInput,
    condition?: ModelTokenTopUpConditionInput
  ): Promise<UpdateTokenTopUpMutation> {
    const statement = `mutation UpdateTokenTopUp($input: UpdateTokenTopUpInput!, $condition: ModelTokenTopUpConditionInput) {
        updateTokenTopUp(input: $input, condition: $condition) {
          __typename
          id
          token
          amount
          action
          apiLog
          billingId
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateTokenTopUpMutation>response.data.updateTokenTopUp;
  }
  async DeleteTokenTopUp(
    input: DeleteTokenTopUpInput,
    condition?: ModelTokenTopUpConditionInput
  ): Promise<DeleteTokenTopUpMutation> {
    const statement = `mutation DeleteTokenTopUp($input: DeleteTokenTopUpInput!, $condition: ModelTokenTopUpConditionInput) {
        deleteTokenTopUp(input: $input, condition: $condition) {
          __typename
          id
          token
          amount
          action
          apiLog
          billingId
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteTokenTopUpMutation>response.data.deleteTokenTopUp;
  }
  async CreateBilling(
    input: CreateBillingInput,
    condition?: ModelBillingConditionInput
  ): Promise<CreateBillingMutation> {
    const statement = `mutation CreateBilling($input: CreateBillingInput!, $condition: ModelBillingConditionInput) {
        createBilling(input: $input, condition: $condition) {
          __typename
          id
          amount
          amountNoTax
          date
          valid
          Billing_ShovarNumber
          email
          SKU
          productPrice
          subscriptionPrice
          quantity
          owner
          tokenAmount
          type
          companyId
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateBillingMutation>response.data.createBilling;
  }
  async UpdateBilling(
    input: UpdateBillingInput,
    condition?: ModelBillingConditionInput
  ): Promise<UpdateBillingMutation> {
    const statement = `mutation UpdateBilling($input: UpdateBillingInput!, $condition: ModelBillingConditionInput) {
        updateBilling(input: $input, condition: $condition) {
          __typename
          id
          amount
          amountNoTax
          date
          valid
          Billing_ShovarNumber
          email
          SKU
          productPrice
          subscriptionPrice
          quantity
          owner
          tokenAmount
          type
          companyId
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateBillingMutation>response.data.updateBilling;
  }
  async DeleteBilling(
    input: DeleteBillingInput,
    condition?: ModelBillingConditionInput
  ): Promise<DeleteBillingMutation> {
    const statement = `mutation DeleteBilling($input: DeleteBillingInput!, $condition: ModelBillingConditionInput) {
        deleteBilling(input: $input, condition: $condition) {
          __typename
          id
          amount
          amountNoTax
          date
          valid
          Billing_ShovarNumber
          email
          SKU
          productPrice
          subscriptionPrice
          quantity
          owner
          tokenAmount
          type
          companyId
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteBillingMutation>response.data.deleteBilling;
  }
  async CreateSumit(
    input: CreateSumitInput,
    condition?: ModelSumitConditionInput
  ): Promise<CreateSumitMutation> {
    const statement = `mutation CreateSumit($input: CreateSumitInput!, $condition: ModelSumitConditionInput) {
        createSumit(input: $input, condition: $condition) {
          __typename
          id
          customerId
          name
          phone
          email
          companyNumber
          customerHistoryURL
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateSumitMutation>response.data.createSumit;
  }
  async UpdateSumit(
    input: UpdateSumitInput,
    condition?: ModelSumitConditionInput
  ): Promise<UpdateSumitMutation> {
    const statement = `mutation UpdateSumit($input: UpdateSumitInput!, $condition: ModelSumitConditionInput) {
        updateSumit(input: $input, condition: $condition) {
          __typename
          id
          customerId
          name
          phone
          email
          companyNumber
          customerHistoryURL
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateSumitMutation>response.data.updateSumit;
  }
  async DeleteSumit(
    input: DeleteSumitInput,
    condition?: ModelSumitConditionInput
  ): Promise<DeleteSumitMutation> {
    const statement = `mutation DeleteSumit($input: DeleteSumitInput!, $condition: ModelSumitConditionInput) {
        deleteSumit(input: $input, condition: $condition) {
          __typename
          id
          customerId
          name
          phone
          email
          companyNumber
          customerHistoryURL
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteSumitMutation>response.data.deleteSumit;
  }
  async CreateSumitPayment(
    input: CreateSumitPaymentInput,
    condition?: ModelSumitPaymentConditionInput
  ): Promise<CreateSumitPaymentMutation> {
    const statement = `mutation CreateSumitPayment($input: CreateSumitPaymentInput!, $condition: ModelSumitPaymentConditionInput) {
        createSumitPayment(input: $input, condition: $condition) {
          __typename
          id
          status
          OGCustomerID
          OGPaymentID
          OGPaymentType
          OGDocumentNumber
          subscriptionPrice
          owner
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateSumitPaymentMutation>response.data.createSumitPayment;
  }
  async UpdateSumitPayment(
    input: UpdateSumitPaymentInput,
    condition?: ModelSumitPaymentConditionInput
  ): Promise<UpdateSumitPaymentMutation> {
    const statement = `mutation UpdateSumitPayment($input: UpdateSumitPaymentInput!, $condition: ModelSumitPaymentConditionInput) {
        updateSumitPayment(input: $input, condition: $condition) {
          __typename
          id
          status
          OGCustomerID
          OGPaymentID
          OGPaymentType
          OGDocumentNumber
          subscriptionPrice
          owner
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateSumitPaymentMutation>response.data.updateSumitPayment;
  }
  async DeleteSumitPayment(
    input: DeleteSumitPaymentInput,
    condition?: ModelSumitPaymentConditionInput
  ): Promise<DeleteSumitPaymentMutation> {
    const statement = `mutation DeleteSumitPayment($input: DeleteSumitPaymentInput!, $condition: ModelSumitPaymentConditionInput) {
        deleteSumitPayment(input: $input, condition: $condition) {
          __typename
          id
          status
          OGCustomerID
          OGPaymentID
          OGPaymentType
          OGDocumentNumber
          subscriptionPrice
          owner
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteSumitPaymentMutation>response.data.deleteSumitPayment;
  }
  async CreateSumitPaymentMethod(
    input: CreateSumitPaymentMethodInput,
    condition?: ModelSumitPaymentMethodConditionInput
  ): Promise<CreateSumitPaymentMethodMutation> {
    const statement = `mutation CreateSumitPaymentMethod($input: CreateSumitPaymentMethodInput!, $condition: ModelSumitPaymentMethodConditionInput) {
        createSumitPaymentMethod(input: $input, condition: $condition) {
          __typename
          id
          status
          PaymentMethodID
          CustomerID
          CompanyID
          CardMask
          LastDigits
          ExpirationMonth
          ExpirationYear
          Token
          Type
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateSumitPaymentMethodMutation>(
      response.data.createSumitPaymentMethod
    );
  }
  async UpdateSumitPaymentMethod(
    input: UpdateSumitPaymentMethodInput,
    condition?: ModelSumitPaymentMethodConditionInput
  ): Promise<UpdateSumitPaymentMethodMutation> {
    const statement = `mutation UpdateSumitPaymentMethod($input: UpdateSumitPaymentMethodInput!, $condition: ModelSumitPaymentMethodConditionInput) {
        updateSumitPaymentMethod(input: $input, condition: $condition) {
          __typename
          id
          status
          PaymentMethodID
          CustomerID
          CompanyID
          CardMask
          LastDigits
          ExpirationMonth
          ExpirationYear
          Token
          Type
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateSumitPaymentMethodMutation>(
      response.data.updateSumitPaymentMethod
    );
  }
  async DeleteSumitPaymentMethod(
    input: DeleteSumitPaymentMethodInput,
    condition?: ModelSumitPaymentMethodConditionInput
  ): Promise<DeleteSumitPaymentMethodMutation> {
    const statement = `mutation DeleteSumitPaymentMethod($input: DeleteSumitPaymentMethodInput!, $condition: ModelSumitPaymentMethodConditionInput) {
        deleteSumitPaymentMethod(input: $input, condition: $condition) {
          __typename
          id
          status
          PaymentMethodID
          CustomerID
          CompanyID
          CardMask
          LastDigits
          ExpirationMonth
          ExpirationYear
          Token
          Type
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteSumitPaymentMethodMutation>(
      response.data.deleteSumitPaymentMethod
    );
  }
  async GetApiLog(id: string): Promise<GetApiLogQuery> {
    const statement = `query GetApiLog($id: ID!) {
        getApiLog(id: $id) {
          __typename
          id
          uuid
          datetime
          path
          fileUid
          owner
          amountPerPath
          type
          clientId
          clientVersion
          clientIp
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetApiLogQuery>response.data.getApiLog;
  }
  async ListApiLogs(
    filter?: ModelApiLogFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListApiLogsQuery> {
    const statement = `query ListApiLogs($filter: ModelApiLogFilterInput, $limit: Int, $nextToken: String) {
        listApiLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            uuid
            datetime
            path
            fileUid
            owner
            amountPerPath
            type
            clientId
            clientVersion
            clientIp
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListApiLogsQuery>response.data.listApiLogs;
  }
  async GetTokens(id: string): Promise<GetTokensQuery> {
    const statement = `query GetTokens($id: ID!) {
        getTokens(id: $id) {
          __typename
          id
          name
          date
          enable
          month
          uuid
          description
          type
          owner
          userExists
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetTokensQuery>response.data.getTokens;
  }
  async ListTokens(
    filter?: ModelTokensFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTokensQuery> {
    const statement = `query ListTokens($filter: ModelTokensFilterInput, $limit: Int, $nextToken: String) {
        listTokens(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            enable
            month
            uuid
            description
            type
            owner
            userExists
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListTokensQuery>response.data.listTokens;
  }
  async GetTokenTopUp(id: string): Promise<GetTokenTopUpQuery> {
    const statement = `query GetTokenTopUp($id: ID!) {
        getTokenTopUp(id: $id) {
          __typename
          id
          token
          amount
          action
          apiLog
          billingId
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetTokenTopUpQuery>response.data.getTokenTopUp;
  }
  async ListTokenTopUps(
    filter?: ModelTokenTopUpFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTokenTopUpsQuery> {
    const statement = `query ListTokenTopUps($filter: ModelTokenTopUpFilterInput, $limit: Int, $nextToken: String) {
        listTokenTopUps(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            token
            amount
            action
            apiLog
            billingId
            owner
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListTokenTopUpsQuery>response.data.listTokenTopUps;
  }
  async GetBilling(id: string): Promise<GetBillingQuery> {
    const statement = `query GetBilling($id: ID!) {
        getBilling(id: $id) {
          __typename
          id
          amount
          amountNoTax
          date
          valid
          Billing_ShovarNumber
          email
          SKU
          productPrice
          subscriptionPrice
          quantity
          owner
          tokenAmount
          type
          companyId
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetBillingQuery>response.data.getBilling;
  }
  async ListBillings(
    filter?: ModelBillingFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListBillingsQuery> {
    const statement = `query ListBillings($filter: ModelBillingFilterInput, $limit: Int, $nextToken: String) {
        listBillings(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            amount
            amountNoTax
            date
            valid
            Billing_ShovarNumber
            email
            SKU
            productPrice
            subscriptionPrice
            quantity
            owner
            tokenAmount
            type
            companyId
            documentDownloadURL
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListBillingsQuery>response.data.listBillings;
  }
  async GetSumit(id: string): Promise<GetSumitQuery> {
    const statement = `query GetSumit($id: ID!) {
        getSumit(id: $id) {
          __typename
          id
          customerId
          name
          phone
          email
          companyNumber
          customerHistoryURL
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetSumitQuery>response.data.getSumit;
  }
  async ListSumits(
    filter?: ModelSumitFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListSumitsQuery> {
    const statement = `query ListSumits($filter: ModelSumitFilterInput, $limit: Int, $nextToken: String) {
        listSumits(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            customerId
            name
            phone
            email
            companyNumber
            customerHistoryURL
            owner
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListSumitsQuery>response.data.listSumits;
  }
  async GetSumitPayment(id: string): Promise<GetSumitPaymentQuery> {
    const statement = `query GetSumitPayment($id: ID!) {
        getSumitPayment(id: $id) {
          __typename
          id
          status
          OGCustomerID
          OGPaymentID
          OGPaymentType
          OGDocumentNumber
          subscriptionPrice
          owner
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetSumitPaymentQuery>response.data.getSumitPayment;
  }
  async ListSumitPayments(
    filter?: ModelSumitPaymentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListSumitPaymentsQuery> {
    const statement = `query ListSumitPayments($filter: ModelSumitPaymentFilterInput, $limit: Int, $nextToken: String) {
        listSumitPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            status
            OGCustomerID
            OGPaymentID
            OGPaymentType
            OGDocumentNumber
            subscriptionPrice
            owner
            documentDownloadURL
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListSumitPaymentsQuery>response.data.listSumitPayments;
  }
  async GetSumitPaymentMethod(id: string): Promise<GetSumitPaymentMethodQuery> {
    const statement = `query GetSumitPaymentMethod($id: ID!) {
        getSumitPaymentMethod(id: $id) {
          __typename
          id
          status
          PaymentMethodID
          CustomerID
          CompanyID
          CardMask
          LastDigits
          ExpirationMonth
          ExpirationYear
          Token
          Type
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetSumitPaymentMethodQuery>response.data.getSumitPaymentMethod;
  }
  async ListSumitPaymentMethods(
    filter?: ModelSumitPaymentMethodFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListSumitPaymentMethodsQuery> {
    const statement = `query ListSumitPaymentMethods($filter: ModelSumitPaymentMethodFilterInput, $limit: Int, $nextToken: String) {
        listSumitPaymentMethods(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            status
            PaymentMethodID
            CustomerID
            CompanyID
            CardMask
            LastDigits
            ExpirationMonth
            ExpirationYear
            Token
            Type
            owner
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListSumitPaymentMethodsQuery>response.data.listSumitPaymentMethods;
  }
  OnCreateApiLogListener(
    filter?: ModelSubscriptionApiLogFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateApiLog">>
  > {
    const statement = `subscription OnCreateApiLog($filter: ModelSubscriptionApiLogFilterInput, $owner: String) {
        onCreateApiLog(filter: $filter, owner: $owner) {
          __typename
          id
          uuid
          datetime
          path
          fileUid
          owner
          amountPerPath
          type
          clientId
          clientVersion
          clientIp
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateApiLog">>
    >;
  }

  OnUpdateApiLogListener(
    filter?: ModelSubscriptionApiLogFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateApiLog">>
  > {
    const statement = `subscription OnUpdateApiLog($filter: ModelSubscriptionApiLogFilterInput, $owner: String) {
        onUpdateApiLog(filter: $filter, owner: $owner) {
          __typename
          id
          uuid
          datetime
          path
          fileUid
          owner
          amountPerPath
          type
          clientId
          clientVersion
          clientIp
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateApiLog">>
    >;
  }

  OnDeleteApiLogListener(
    filter?: ModelSubscriptionApiLogFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteApiLog">>
  > {
    const statement = `subscription OnDeleteApiLog($filter: ModelSubscriptionApiLogFilterInput, $owner: String) {
        onDeleteApiLog(filter: $filter, owner: $owner) {
          __typename
          id
          uuid
          datetime
          path
          fileUid
          owner
          amountPerPath
          type
          clientId
          clientVersion
          clientIp
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteApiLog">>
    >;
  }

  OnCreateTokensListener(
    filter?: ModelSubscriptionTokensFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateTokens">>
  > {
    const statement = `subscription OnCreateTokens($filter: ModelSubscriptionTokensFilterInput, $owner: String) {
        onCreateTokens(filter: $filter, owner: $owner) {
          __typename
          id
          name
          date
          enable
          month
          uuid
          description
          type
          owner
          userExists
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateTokens">>
    >;
  }

  OnUpdateTokensListener(
    filter?: ModelSubscriptionTokensFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateTokens">>
  > {
    const statement = `subscription OnUpdateTokens($filter: ModelSubscriptionTokensFilterInput, $owner: String) {
        onUpdateTokens(filter: $filter, owner: $owner) {
          __typename
          id
          name
          date
          enable
          month
          uuid
          description
          type
          owner
          userExists
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateTokens">>
    >;
  }

  OnDeleteTokensListener(
    filter?: ModelSubscriptionTokensFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteTokens">>
  > {
    const statement = `subscription OnDeleteTokens($filter: ModelSubscriptionTokensFilterInput, $owner: String) {
        onDeleteTokens(filter: $filter, owner: $owner) {
          __typename
          id
          name
          date
          enable
          month
          uuid
          description
          type
          owner
          userExists
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteTokens">>
    >;
  }

  OnCreateTokenTopUpListener(
    filter?: ModelSubscriptionTokenTopUpFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateTokenTopUp">>
  > {
    const statement = `subscription OnCreateTokenTopUp($filter: ModelSubscriptionTokenTopUpFilterInput, $owner: String) {
        onCreateTokenTopUp(filter: $filter, owner: $owner) {
          __typename
          id
          token
          amount
          action
          apiLog
          billingId
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateTokenTopUp">>
    >;
  }

  OnUpdateTokenTopUpListener(
    filter?: ModelSubscriptionTokenTopUpFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateTokenTopUp">>
  > {
    const statement = `subscription OnUpdateTokenTopUp($filter: ModelSubscriptionTokenTopUpFilterInput, $owner: String) {
        onUpdateTokenTopUp(filter: $filter, owner: $owner) {
          __typename
          id
          token
          amount
          action
          apiLog
          billingId
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateTokenTopUp">>
    >;
  }

  OnDeleteTokenTopUpListener(
    filter?: ModelSubscriptionTokenTopUpFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteTokenTopUp">>
  > {
    const statement = `subscription OnDeleteTokenTopUp($filter: ModelSubscriptionTokenTopUpFilterInput, $owner: String) {
        onDeleteTokenTopUp(filter: $filter, owner: $owner) {
          __typename
          id
          token
          amount
          action
          apiLog
          billingId
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteTokenTopUp">>
    >;
  }

  OnCreateBillingListener(
    filter?: ModelSubscriptionBillingFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateBilling">>
  > {
    const statement = `subscription OnCreateBilling($filter: ModelSubscriptionBillingFilterInput, $owner: String) {
        onCreateBilling(filter: $filter, owner: $owner) {
          __typename
          id
          amount
          amountNoTax
          date
          valid
          Billing_ShovarNumber
          email
          SKU
          productPrice
          subscriptionPrice
          quantity
          owner
          tokenAmount
          type
          companyId
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateBilling">>
    >;
  }

  OnUpdateBillingListener(
    filter?: ModelSubscriptionBillingFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateBilling">>
  > {
    const statement = `subscription OnUpdateBilling($filter: ModelSubscriptionBillingFilterInput, $owner: String) {
        onUpdateBilling(filter: $filter, owner: $owner) {
          __typename
          id
          amount
          amountNoTax
          date
          valid
          Billing_ShovarNumber
          email
          SKU
          productPrice
          subscriptionPrice
          quantity
          owner
          tokenAmount
          type
          companyId
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateBilling">>
    >;
  }

  OnDeleteBillingListener(
    filter?: ModelSubscriptionBillingFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteBilling">>
  > {
    const statement = `subscription OnDeleteBilling($filter: ModelSubscriptionBillingFilterInput, $owner: String) {
        onDeleteBilling(filter: $filter, owner: $owner) {
          __typename
          id
          amount
          amountNoTax
          date
          valid
          Billing_ShovarNumber
          email
          SKU
          productPrice
          subscriptionPrice
          quantity
          owner
          tokenAmount
          type
          companyId
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteBilling">>
    >;
  }

  OnCreateSumitListener(
    filter?: ModelSubscriptionSumitFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateSumit">>
  > {
    const statement = `subscription OnCreateSumit($filter: ModelSubscriptionSumitFilterInput, $owner: String) {
        onCreateSumit(filter: $filter, owner: $owner) {
          __typename
          id
          customerId
          name
          phone
          email
          companyNumber
          customerHistoryURL
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateSumit">>
    >;
  }

  OnUpdateSumitListener(
    filter?: ModelSubscriptionSumitFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateSumit">>
  > {
    const statement = `subscription OnUpdateSumit($filter: ModelSubscriptionSumitFilterInput, $owner: String) {
        onUpdateSumit(filter: $filter, owner: $owner) {
          __typename
          id
          customerId
          name
          phone
          email
          companyNumber
          customerHistoryURL
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateSumit">>
    >;
  }

  OnDeleteSumitListener(
    filter?: ModelSubscriptionSumitFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteSumit">>
  > {
    const statement = `subscription OnDeleteSumit($filter: ModelSubscriptionSumitFilterInput, $owner: String) {
        onDeleteSumit(filter: $filter, owner: $owner) {
          __typename
          id
          customerId
          name
          phone
          email
          companyNumber
          customerHistoryURL
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteSumit">>
    >;
  }

  OnCreateSumitPaymentListener(
    filter?: ModelSubscriptionSumitPaymentFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateSumitPayment">>
  > {
    const statement = `subscription OnCreateSumitPayment($filter: ModelSubscriptionSumitPaymentFilterInput, $owner: String) {
        onCreateSumitPayment(filter: $filter, owner: $owner) {
          __typename
          id
          status
          OGCustomerID
          OGPaymentID
          OGPaymentType
          OGDocumentNumber
          subscriptionPrice
          owner
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onCreateSumitPayment">
      >
    >;
  }

  OnUpdateSumitPaymentListener(
    filter?: ModelSubscriptionSumitPaymentFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateSumitPayment">>
  > {
    const statement = `subscription OnUpdateSumitPayment($filter: ModelSubscriptionSumitPaymentFilterInput, $owner: String) {
        onUpdateSumitPayment(filter: $filter, owner: $owner) {
          __typename
          id
          status
          OGCustomerID
          OGPaymentID
          OGPaymentType
          OGDocumentNumber
          subscriptionPrice
          owner
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateSumitPayment">
      >
    >;
  }

  OnDeleteSumitPaymentListener(
    filter?: ModelSubscriptionSumitPaymentFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteSumitPayment">>
  > {
    const statement = `subscription OnDeleteSumitPayment($filter: ModelSubscriptionSumitPaymentFilterInput, $owner: String) {
        onDeleteSumitPayment(filter: $filter, owner: $owner) {
          __typename
          id
          status
          OGCustomerID
          OGPaymentID
          OGPaymentType
          OGDocumentNumber
          subscriptionPrice
          owner
          documentDownloadURL
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onDeleteSumitPayment">
      >
    >;
  }

  OnCreateSumitPaymentMethodListener(
    filter?: ModelSubscriptionSumitPaymentMethodFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onCreateSumitPaymentMethod">
    >
  > {
    const statement = `subscription OnCreateSumitPaymentMethod($filter: ModelSubscriptionSumitPaymentMethodFilterInput, $owner: String) {
        onCreateSumitPaymentMethod(filter: $filter, owner: $owner) {
          __typename
          id
          status
          PaymentMethodID
          CustomerID
          CompanyID
          CardMask
          LastDigits
          ExpirationMonth
          ExpirationYear
          Token
          Type
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onCreateSumitPaymentMethod">
      >
    >;
  }

  OnUpdateSumitPaymentMethodListener(
    filter?: ModelSubscriptionSumitPaymentMethodFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onUpdateSumitPaymentMethod">
    >
  > {
    const statement = `subscription OnUpdateSumitPaymentMethod($filter: ModelSubscriptionSumitPaymentMethodFilterInput, $owner: String) {
        onUpdateSumitPaymentMethod(filter: $filter, owner: $owner) {
          __typename
          id
          status
          PaymentMethodID
          CustomerID
          CompanyID
          CardMask
          LastDigits
          ExpirationMonth
          ExpirationYear
          Token
          Type
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateSumitPaymentMethod">
      >
    >;
  }

  OnDeleteSumitPaymentMethodListener(
    filter?: ModelSubscriptionSumitPaymentMethodFilterInput,
    owner?: string
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onDeleteSumitPaymentMethod">
    >
  > {
    const statement = `subscription OnDeleteSumitPaymentMethod($filter: ModelSubscriptionSumitPaymentMethodFilterInput, $owner: String) {
        onDeleteSumitPaymentMethod(filter: $filter, owner: $owner) {
          __typename
          id
          status
          PaymentMethodID
          CustomerID
          CompanyID
          CardMask
          LastDigits
          ExpirationMonth
          ExpirationYear
          Token
          Type
          owner
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (owner) {
      gqlAPIServiceArguments.owner = owner;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onDeleteSumitPaymentMethod">
      >
    >;
  }
}
